module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "ion-thumbnail"
  }, [_h('img', {
    attrs: {
      "src": src,
      "alt": ""
    }
  })])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-383df9e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/thumbnail/src/thumbnail.vue
// module id = 156
// module chunks = 0